import React, { Component } from 'react';
import ScrollToTop from 'react-scroll-up';

// eslint-disable-next-line
class BackToTop extends Component {
  render() {
    const style = {
      zIndex: '20',
    };
    return (
      <ScrollToTop showUnder={200} style={style}>
        <span className="back-to-top">&nbsp;⟵<br /> Back</span>
      </ScrollToTop>
    );
  }
}

export default BackToTop;



// WEBPACK FOOTER //
// ./client/js/components/shared/BackToTop.js